import * as reportServices from '../services/report';

export default {
  namespace: 'report',

  state: { chart1Data: {} },

  effects: {
    //活跃会员
    *getActiveMember({ payload }, { call, put, select }) {
      const response = yield call(reportServices.getActiveMember, payload);
      const chart1Data = yield select((state) => state.report.chart1Data);

      yield put({
        type: 'save',
        payload: {
          chart1Data: { ...chart1Data, getActiveMember: response },
        },
      });
    },
    //首购会员
    *getFirstPurchaser({ payload }, { call, put, select }) {
      const response = yield call(reportServices.getFirstPurchaser, payload);
      const chart1Data = yield select((state) => state.report.chart1Data);
      yield put({
        type: 'save',
        payload: {
          chart1Data: { ...chart1Data, getFirstPurchaser: response },
        },
      });
    },
    //复购会员
    *getRepeatPurchaser({ payload }, { call, put, select }) {
      const response = yield call(reportServices.getRepeatPurchaser, payload);
      const chart1Data = yield select((state) => state.report.chart1Data);

      yield put({
        type: 'save',
        payload: {
          chart1Data: { ...chart1Data, getRepeatPurchaser: response },
        },
      });
    },
    //总积分
    *getPointProduce({ payload }, { call, put, select }) {
      const response = yield call(reportServices.getPointProduce, payload);
      const chart1Data = yield select((state) => state.report.chart1Data);

      yield put({
        type: 'save',
        payload: {
          chart1Data: { ...chart1Data, getPointProduce: response },
        },
      });
    },
    //核销积分
    *getPointConsume({ payload }, { call, put, select }) {
      const response = yield call(reportServices.getPointConsume, payload);
      const chart1Data = yield select((state) => state.report.chart1Data);

      yield put({
        type: 'save',
        payload: {
          chart1Data: { ...chart1Data, getPointConsume: response },
        },
      });
    },
    //会员总量
    *getMemberStatistics({ payload }, { call, put }) {
      const response = yield call(reportServices.getMemberStatistics, payload);
      yield put({
        type: 'save',
        payload: {
          getMemberStatistics: response,
        },
      });
    },
    //积分变化趋势
    *getPointTrend({ payload }, { call, put }) {
      const response = yield call(reportServices.getPointTrend, payload);
      yield put({
        type: 'save',
        payload: {
          getPointTrend: response,
        },
      });
    },
    //积分获取方式
    *getAddPointWay({ payload }, { call, put }) {
      const response = yield call(reportServices.getAddPointWay, payload);
      yield put({
        type: 'save',
        payload: {
          getAddPointWay: response,
        },
      });
    },
    //积分扣减方式
    *getSubtractPointWay({ payload }, { call, put }) {
      const response = yield call(reportServices.getSubtractPointWay, payload);
      yield put({
        type: 'save',
        payload: {
          getSubtractPointWay: response,
        },
      });
    },
    //活跃会员积分核销比
    *getRate({ payload }, { call, put }) {
      const response = yield call(reportServices.getRate, payload);
      yield put({
        type: 'save',
        payload: {
          getRate: response,
        },
      });
    },
    //商品件数构成
    *getGoodsTrend({ payload }, { call, put }) {
      const response = yield call(reportServices.getGoodsTrend, payload);
      yield put({
        type: 'save',
        payload: {
          getGoodsTrend: response,
        },
      });
    },
    //会员客单价
    *getGuestUnitPrice({ payload }, { call, put }) {
      const response = yield call(reportServices.getGuestUnitPrice, payload);
      yield put({
        type: 'save',
        payload: {
          getGuestUnitPrice: response,
        },
      });
    },
    //会员订单构成
    *getMemberOrderAssemble({ payload }, { call, put }) {
      const response = yield call(
        reportServices.getMemberOrderAssemble,
        payload,
      );
      yield put({
        type: 'save',
        payload: {
          getMemberOrderAssemble: response,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
